// Evenements ecommerce pousses dans dataLayer pour GTM (add_to_cart, select_promotion de la home).
// L'app Shopify "Google & YouTube" envoie deja nativement a GA4 et Google Ads page_view, view_item,
// add_to_cart, begin_checkout et purchase : aucune balise GTM ne doit relayer add_to_cart (doublon).
// begin_checkout n'est plus pousse ici depuis le 2026-10-22 : il doublait l'evenement natif de l'app
// (audit tracking, docs/TRACKING_AUDIT_2026.md) et retardait le passage au paiement d'un appel /cart.js.
(function () {
  'use strict';

  function pushEcommerceEvent(eventName, items, currency) {
    if (!items || !items.length) return;
    var value = items.reduce(function (sum, item) {
      return sum + (Number(item.price) || 0) * (Number(item.quantity) || 1);
    }, 0);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: eventName,
      ecommerce: {
        currency: currency || 'EUR',
        value: Math.round(value * 100) / 100,
        items: items
      }
    });
  }

  // Normalise une reponse Shopify /cart/add.js (format plat single-item ou {items:[...]})
  // vers le format d'items GA4 recommande.
  function itemsFromCartResponse(raw) {
    if (!raw) return [];
    var list = Array.isArray(raw.items) ? raw.items : [raw];
    return list
      .filter(function (i) { return i && (i.variant_id || i.id); })
      .map(function (i) {
        return {
          item_id: String(i.variant_id || i.id),
          item_name: i.product_title || i.title || '',
          price: (i.price || i.final_price || 0) / 100,
          quantity: i.quantity || 1,
          item_brand: i.vendor || undefined
        };
      });
  }

  window.QnGA4 = {
    push: pushEcommerceEvent,
    itemsFromCartResponse: itemsFromCartResponse
  };

  function initAddToCartTracking() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form' || !event.cartData || event.cartData.status) return;
      pushEcommerceEvent('add_to_cart', itemsFromCartResponse(event.cartData), 'EUR');
    });
  }

  // Lot P0 du 2026-10-18 : clics par section de la page d'accueil (select_promotion), pour avoir
  // un « avant » mesurable avant la refonte de janvier. Aucun HTML de section n'est modifié :
  // la section se déduit de l'id Shopify « shopify-section-template--…__<clé> ».
  // Un élément peut forcer son libellé avec data-qn-promo="…" (prévu pour la future home).
  // N'atteint GA4 que via une balise GTM relais (déclencheur sur l'événement select_promotion).
  function isHomePage() {
    var p = window.location.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/|$)/i, '');
    return p === '' || p === '/';
  }

  function initHomeSectionTracking() {
    if (!isHomePage()) return;
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a[href]');
      if (!link) return;
      var section = link.closest('[id^="shopify-section-template--"]');
      if (!section) return; // en-tête, pied de page et barre d'annonce exclus
      var key = section.id.split('__').pop().replace(/_[A-Za-z0-9]{6}$/, '');
      var sections = Array.prototype.slice.call(document.querySelectorAll('[id^="shopify-section-template--"]'));
      var links = Array.prototype.slice.call(section.querySelectorAll('a[href]'));
      var forced = link.closest('[data-qn-promo]');
      var label = forced ? forced.getAttribute('data-qn-promo')
        : (link.getAttribute('aria-label') || link.textContent || '').replace(/\s+/g, ' ').trim();
      var dest = '';
      try { dest = new URL(link.href, window.location.origin).pathname; } catch (err) { dest = link.getAttribute('href'); }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'select_promotion',
        ecommerce: {
          promotion_id: 'home_' + key,
          promotion_name: dest,
          creative_name: label.slice(0, 100),
          creative_slot: 'section_' + (sections.indexOf(section) + 1) + '_lien_' + (links.indexOf(link) + 1),
          location_id: 'home'
        }
      });
    }, { capture: true, passive: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAddToCartTracking();
    initHomeSectionTracking();
  });
})();
